import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'Home', path: '/' },
    { name: 'Data Services', path: '/data-engineering' },
    { name: 'Cloud Services', path: '/cloud-engineering' },
    { name: 'AI Services', path: '/ai-services' },
    { name: 'Engineering Talent', path: '/talent-pods' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' },
  ];

  return (
    <footer className="bg-secondary border-t border-border" data-testid="footer">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4" data-testid="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_engineering-hub-38/artifacts/fa816qty_cynergy%20logo.jpg" 
                alt="Cynergy Services" 
                className="h-10 w-auto rounded-sm"
                style={{ 
                  mixBlendMode: 'multiply',
                  backgroundColor: 'transparent'
                }}
              />
            </Link>
            <p className="text-sm text-muted-foreground mb-6">
              Data, Cloud & AI Engineering Studio
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:info@cynergyservices.org"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4" />
                info@cynergyservices.org
              </a>
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Services
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.slice(1, 5).map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h4 className="font-semibold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Locations
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-2 text-sm text-muted-foreground" data-testid="footer-location-india">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-foreground">India</p>
                  <p>Noida, Uttar Pradesh, 201306</p>
                </div>
              </div>
              <div className="flex items-start gap-2 text-sm text-muted-foreground" data-testid="footer-location-singapore">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-foreground">Singapore</p>
                  <p>Melville Park, Singapore, 529942</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-semibold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Ready to start?
            </h4>
            <p className="text-sm text-muted-foreground mb-4">
              Let's discuss how we can help with your data, cloud or AI challenges.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground rounded-sm text-sm font-medium hover:bg-primary/90 transition-colors duration-200"
              data-testid="footer-cta"
            >
              Get in touch
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground" data-testid="footer-copyright">
            © {currentYear} Cynergy Services. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground">
            Serving clients in India, Singapore, APAC and beyond
          </p>
        </div>
      </div>
    </footer>
  );
};
